<template lang="pug">
  #app(ref="app")
    div(@login-as="loginAs")
    .links(v-if="loggedIn")
      a(href="#", @click.prevent="displayGuestList" v-if="user.can_see_guestlist")
        span GL
        i.fa.fa-calendar-check-o
      a(href="#", @click.prevent="displayVacations")
        span Urlaub
        i.fa.fa-plane
      a(href="#", @click.prevent="displayShiftPlan",
        v-if="user.can_view_shift_plan",)
        span Schichten
        i.fa.fa-calendar
      a(href="#", @click.prevent="showEmployeeList=true")
        span Team
        i.fa.fa-users
      a(href="#", @click.prevent="loadNews()")
        span News
        i.fa.fa-newspaper-o
      a(href="#", @click.prevent="logout" style="margin-right: 17px;")
        span
        i.fa.fa-sign-out

    form.loginForm(v-if="!loggedIn")
      .section
        .columns
          .column Bitte logge Dich ein, um Deine aktuellen Schichten zu sehen.
            br
            | Falls Du dein Passwort vergessen hast, oder Dich zum ersten
            | Mal hier anmelden willst, bitte&nbsp;
            a(href="https://salat.pepperz.de/admin-tools/password_reset/", target="_blank") hier entlang
            | .
        .columns
          .column
            p.control.has-icon.has-icon-right
              input.input(name="username", v-model="username", placeholder="eMail")
              i.fa.fa-user
            p.control.has-icon.has-icon-right
              input.input(name="password", type="password", v-model="password",
                placeholder="Passwort", v-on:keyup.enter="logMeIn")
              i.fa.fa-key.fa-rotate-90
        .columns
          .column
            input(type="checkbox", id="DGSVO", @click="confirmed = !confirmed")
            label(for="DGSVO")  Ich akzeptiere die&nbsp;
              a(:href="this.$root.apiHost + '/datenschutz'") Datenschutzregelungen
            br
            br
            a.button.is-primary(@click="logMeIn", :disabled="!confirmed") einloggen

    .section(v-if="loggedIn")
      b-aside.presence(:is-show="editShiftTimes", title="Anwesenheiten",
          :show-footer="false", @close="editShiftTimes=false" placement="right")
        presence-panel(v-if="editShiftTimes" :user="user")
      b-aside(:is-show="showApplications", title="Bewerbungen",
          :show-footer="false", @close="showApplications=false")
        applications

      b-aside(:is-show="showVacations", title="Urlaub",
          :show-footer="false", @close="showVacations=false")
        vacations(:vacations="vacations", :user="user" v-on:reload-vacations="loadVacations")
      b-aside(:is-show="showNews", title="News",
          :show-footer="false", @close="showNews=false")
        div Hier findest du News vom KA, Deli und aus den Gewerken.
        br


        .newsItem(v-for="item in news" :key="item.id")
          .headline
            .time {{ new Date(item.created) | moment('dd. Do MMM ') }}
            .newsType {{ item.type_display}}
          h2 {{ item.title }}
          .content(v-if="item.showContent")
            .text(v-html="item.content")

            .attachments(v-if="item.attachments.length > 0" )
              b Anhänge:
              ul
                li(v-for="att in item.attachments" :key="att.id")
                  a(:href="apiUrl + att.file" target="_blank") {{ att.name }}

          .buttons
            a.button(href="#" @click="item.showContent = !item.showContent") {{ item.showContent ? 'Ausblenden' : 'Anzeigen' }}
      b-aside(:is-show="showGuestList", title="Gästeliste",
          :show-footer="false", @close="showGuestList=false")
        div(v-if="!currentEvent") Heute keine Veranstaltung.
        div(v-if="currentEvent")
          div
            b VA:&nbsp;
            | {{ currentEvent.name }}
          br
          .search-bar
            input.input(type="text" placeholder="Gast suchen ..." v-model="guestSearch")
            i.fa.fa-times(@click="guestSearch = ''")
          br
          .legend
            span.so36(@click="setCatSearch('so36')" :class="{inactive: catSearch != 'so36' && catSearch != ''}")
              i.fa.fa-beer
              span SO36
            span.band(@click="setCatSearch('band')" :class="{inactive: catSearch != 'band' && catSearch != ''}")
              i.fa.fa-music
              | Band
            span.agency(@click="setCatSearch('agency')" :class="{inactive: catSearch != 'agency' && catSearch != ''}")
              i.fa.fa-briefcase
              span Agentur
            span.win(@click="setCatSearch('win')" :class="{inactive: catSearch != 'win' && catSearch != ''}")
              i.fa.fa-trophy
              span Gewinnspiel
          br
          .guest
            .info.head
              span Kat.
              span Name
              span +X
              span Bänd.
              span Anw.
            .comment
              span
          .guest(v-for="guest in filteredGuests" :class="{selected: selectedGuest && selectedGuest.id == guest.id}")
            .info(@click="selectGuest(guest)")
              span(:class="guest.category")
                i.fa(:class="icons[guest.category]")
              span {{ guest.name }}
              span {{ guest.plus_x > 0 ? '+' + guest.plus_x : '—' }}
              span {{ guest.ribbon ? '✔️' : '✖' }}
              input(type="checkbox" v-model="guest.present" @change="updateGuest(guest)" @click.stop="true" @click="selectedGuest = guest")
            .comment(v-if="selectedGuest && selectedGuest.id == guest.id && guest.comment != ''")
              span
                b Kommentar:&nbsp;
                | {{ guest.comment }}





      // shift plan
      b-aside.plan(:is-show="showShiftPlan", title="Schichtplan", :show-footer="false",
          placement="right", @close="showShiftPlan=false", v-if="user.can_view_shift_plan || user.is_admin")
        .selection
          ul.fields(v-if="canViewAll")
            li(@click="getPlannedDays(null)", :class="{active: !fieldFilter}")
              span(@click="getPlannedDays(null)") Alle
            li(v-for="field in fields", :class="{active: field.id === fieldFilter}", v-if="field.show_shifts")
              span(@click="getPlannedDays(field.id)") {{ field.name }}

        .plan
          template(v-for="day, index in plannedDays")
            a(v-if="day.is_today", id="plan-starts-today")
            planned-day(:day="day", :class="{'gray': index % 2 === 0, 'is-today': day.is_today === true}")

      // Team list
      b-aside.employees(:is-show="showEmployeeList", title="Team", :show-footer="false",
          placement="right", @close="showEmployeeList=false")
        employees-list(:fields="fields", :user="user", @login-as="loginAs")

      .presence(v-if="user.can_record_shift_times")
        .button.yellowbg(@click="editShiftTimes=true") Anwesenheiten erfassen
        br
        br
      .presence(v-if="user.can_view_shift_times && !user.can_record_shift_times")
        .button.yellowbg(@click="editShiftTimes=true") Anwesenheiten einsehen
        br
        br
      span Hi {{user.short_name }}! Hier sind Deine kommenden Schichten:


      shifts(:switchToApplications="switchToApplications", :user="user")
</template>



<script>

export default {
  name: 'app',
  data () {
    return {
      apiUrl: '',
      confirmed: false,
      showApplications: false,
      showEmployeeList: false,
      showVacations: false,
      showShiftPlan: false,
      showGuestList: false,
      showNews: false,
      news: [],
      editShiftTimes: false,
      loginToken: null,
      username: null,
      password: null,
      user: {},
      plannedDays: [],
      fields: [],
      fieldFilter: null,
      vacations: [],
      currentEvent: undefined,
      guests: [],
      guestSearch: '',
      selectedGuest: null,
      guestListTimer: null,
      icons: {
        'band': 'fa-music',
        'so36': 'fa-beer',
        'agency': 'fa-briefcase',
        'win': 'fa-trophy'
      },
      catSearch: ''
    }
  },
  beforeDestroy () {
    clearTimeout(this.guestListTimer)
  },
  methods: {
    updateGuest (guest) {
      console.log('updating guest', guest)
      this.$http.patch('/guest-list-entries/' + guest.id + '/', guest)
        .set({Authorization: 'jwt ' + this.loginToken})
        .then(() => {})
    },
    loadNews () {
      this.showNews = true
      this.$http.get('/news/')
        .set({Authorization: 'jwt ' + this.loginToken})
        .then((response) => {
          let news = response.body

          // load the old list of news items frrom localstorage
          let oldNewsItems = this.$localStorage.get('newsItems') || []

          if (Array.isArray(this.news)) {
            news.forEach(item => {
              item.showContent = !oldNewsItems.includes(item.id)
            })
          }
          this.news = news

          // save the ids of the news items to localstorage
          let newsIds = news.map(item => item.id)
          this.$localStorage.set('newsItems', newsIds)
        })
    },
    selectGuest: function (guest) {
      this.selectedGuest = this.selectedGuest ? null : guest
    },
    setCatSearch: function (cat) {
      if (this.catSearch === cat) {
        this.catSearch = ''
      } else {
        this.catSearch = cat
      }
    },
    loginAs: function (token) {
      this.loginToken = token
      this.loginUser()
      window.location.reload()
    },
    displayShiftPlan: function () {
      this.showShiftPlan = true
      let app = this
      setTimeout(function () {
        let daHin = document.getElementById('plan-starts-today')
        if (daHin) {
          let wieWeit
          if (app.canViewAll) {
            wieWeit = daHin.offsetTop - 90
          } else {
            wieWeit = daHin.offsetTop - 70
          }
          daHin.parentNode.scrollTop = wieWeit
        }
      }, 100)
    },
    displayVacations: function () {
      this.showVacations = true
    },
    displayGuestList: function () {
      this.showGuestList = true
      this.$http.get('/current-event/')
        .set({Authorization: 'jwt ' + this.loginToken})
        .then(res => {
          this.currentEvent = res.body
        })
        .catch(err => {
          console.log(err)
        })
      this.$http.get('/guest-list-entries/')
        .set({Authorization: 'jwt ' + this.loginToken})
        .then(res => {
          this.guests = res.body
        })
        .catch(err => {
          console.log(err)
        })
      this.startGuestListTimer()
    },
    startGuestListTimer () {
      // Setze den Timeout auf 30 Sekunden (30000 Millisekunden)
      this.guestListTimer = setTimeout(() => {
        this.loadGuestListEntries()
        // Starte den Timeout erneut
        this.startGuestListTimer()
      }, 30000)
    },
    loadGuestListEntries: function () {
      this.$http.get('/guest-list-entries/')
        .set({Authorization: 'jwt ' + this.loginToken})
        .then(res => {
          this.guests = res.body
        })
        .catch(err => {
          console.log(err)
        })
    },
    switchToApplications: function () {
      this.showApplications = true
    },
    changePanel: function (direction) {
      if (direction === 'left') {
        if (this.showVacations) {
          this.showVacations = false
        } else {
          this.showApplications = true
        }
      } else {
        if (this.showApplications) {
          this.showApplications = false
        } else {
          this.showVacations = true
        }
      }
    },
    swipeLeft: function () { this.changePanel('right') },
    swipeRight: function () { this.changePanel('left') },
    loginUser: function () {
      this.$localStorage.set('loginToken', this.loginToken)
      this.$http.get('/current-user/')
        .set({Authorization: 'jwt ' + this.loginToken})
        .then(res => {
          this.user = res.body
          this.getPlannedDays()
          this.loadFields()
          this.loadVacations()
        })
        .catch(err => {
          this.$notify.danger({content: 'Bitte einloggen!'})
          console.log(err)
        })
    },
    logMeIn: function () {
      if (!this.confirmed) return

      this.$http.post('/token-get/')
        .accept('json')
        .send({
          username: this.username.toLowerCase(),
          password: this.password
        }).then(res => {
          this.loginToken = res.body.token
          this.loginUser()
        }).catch((err) => {
          console.log(err.response.body)
          this.$notify.danger({content: 'Login fehlgeschlagen!'})
        })
    },
    logout: function () {
      this.loginToken = undefined
      this.$localStorage.set('loginToken', undefined)
    },
    getPlannedDays: function (filterId) {
      if (this.user.can_view_shift_plan) {
        this.fieldFilter = filterId

        if (!filterId && this.fields.length === 1) {
          this.fieldFilter = this.fields[0].id
        }

        let url = '/planned-days/'

        if (this.fieldFilter) {
          url += '?field_id=' + this.fieldFilter
        }

        this.$http.get(url)
          .set({Authorization: 'jwt ' + this.loginToken})
          .then(res => {
            this.plannedDays = res.body
          })
          .catch(err => {
            this.$notify.danger({content: 'Der Plan konnte nicht geladen werden!'})
            console.log(err)
          })
      }
    },
    loadVacations: function () {
      this.$http.get('/vacations/?year=' + new Date().getFullYear())
        .set({Authorization: 'jwt ' + this.loginToken})
        .then(res => {
          this.vacations = res.body
        })
        .catch(err => {
          console.log(err)
          this.$notify.danger('Urlaubsfehler')
        })
    },
    loadFields: function () {
      this.$http.get('/fields/')
        .set({Authorization: 'jwt ' + this.loginToken})
        .then(res => {
          this.fields = res.body
          this.getPlannedDays()
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  computed: {
    loggedIn: function () {
      return this.loginToken !== undefined
    },
    canViewAll: function () {
      return this.fields.length > 1
    },
    filteredGuests: function () {
      return this.guests.filter(guest => {
        // Falls catSearch gesetzt ist, filtere nach Kategorie
        let categoryMatch = this.catSearch ? guest.category === this.catSearch : true
        // Falls eine Suche eingegeben wurde, filtere auch nach Namen
        let nameMatch = guest.name.toLowerCase().includes(this.guestSearch.toLowerCase())
        return categoryMatch && nameMatch
      })
    }
  },
  created: function () {
    // get the token from the browser to stay logged in
    this.loginToken = this.$localStorage.get('loginToken')
    // check the token and maybe get a new one
    this.$http.post('/token-verify/')
      .send({token: this.loginToken})
      .accept('json')
      .then(res => {
      }).catch(() => {
        this.loginToken = undefined
        this.$localStorage.set('loginToken', undefined)
      })
    if (this.loginToken) {
      this.loginUser()
    }

    // determine the api url
    let host = window.location.hostname
    if (host === 'schichtplan.pepperz.de') {
      host = 'salat.pepperz.de'
    }
    if (host === 'schichtplan.yaamxso36.de') {
      host = 'salat.yaamxso36.de'
    }
    if (host === 'schichtplantest.pepperz.de') {
      host = 'salatverkostung.pepperz.de'
    }

    let apiUrl = window.location.protocol + '//' + host
    if (window.location.hostname === 'localhost' || window.location.hostname.startsWith('192.')) {
      apiUrl += ':8000'
    }
    this.apiUrl = apiUrl
  }
}
</script>


<style lang="sass">
.newsItem
  background: #f4f4f4
  padding: 10px
  margin-bottom: 10px

  .headline
    display: flex
    justify-content: space-between
    margin-bottom: 5px

  h2
    font-weight: bold

  .time, .newsType
    font-weight: bold
    font-size: 17px

  .attachments
    margin-top: 17px

  .buttons
    display: flex
    justify-content: center

  .content, h2
    margin-bottom: 17px

  .newsType
    color: #2196F3

  ul, ol
    text-align: left
    margin-left: 30px

.search-bar
  display: grid
  grid-template-columns: 1fr 25px

  i
    position: relative
    top: 7px
    left: 5px
    cursor: pointer

.legend
  display: flex
  justify-content: space-between
  i.fa
    margin-right: 5px

.guest, .legend
  .band
    color: #E91E63
  .so36
    color: #000000
  .agency
    color: #2196F3
  .win
    color: #4CAF50
  .inactive
    color: #ccc


.guest .info
  display: grid
  grid-template-columns: 1fr 4fr 1fr 1fr 1fr
  grid-gap: 5px
  padding: 5px 0
  &.head
    font-weight: bold
    border-bottom: 1px solid #ccc
.guest
  //border-left: 3px solid transparent
  .info, .comment
    padding-left: 5px
  &.selected
    //border-left: 3px solid #ce0400
    background: #eee

.presence section.modal-card-body
  padding: 16px 0

section.modal-card-body
  padding: 16px

.yellowbg.button
  background-color: #eded90


.aside.plan section
  display: flex
  flex-direction: column
  padding: 0
  .plan
    overflow-y: scroll
    padding: 10px

#app
  font-family: 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  color: #2c3e50
  height: 100%

.aside.is-active
  z-index: 2

.touchLayer
  height: 100%

body, html
  height: 100%
  padding: 0
  margin: 0

.links
  text-align: right
  padding: 7px 0 0 0

  a
    margin-left: 10px
    i
      margin-left: 5px

i.fa
  vertical-align: baseline

.el-input-group__append
  width: 25px
  position: relative

h1, h2
  font-weight: normal

.el-carousel__item
  padding: 20px
  background: white

.el-carousel__button
  background: gray

$red: #ce0400

.red
  color: $red
.green
  color: limegreen
.yellow
  color: #d6ce51

.aside-body
  overflow-y: scroll
  -webkit-overflow-scrolling: touch

ul.fields
  display: flex
  justify-content: space-between
  background: #252525
  color: white

  li
    min-width: 50px
    text-align: center
    padding: 5px
    cursor: pointer
    &.active
      background: #454545




</style>



// WEBPACK FOOTER //
// App.vue?ca9ebab2